import { LocationResponseModel } from "@/models/location";

export const findLocationSyncModel = (array: LocationResponseModel[] | undefined, key: string): LocationResponseModel | undefined => {
  if (!array) return undefined;
  for (const item of array) {
    if (item.key == key) return item;
    const result = findLocationSyncModel(item.children, key);
    if (result) return result;
  }
  return undefined;
};
